// extracted by mini-css-extract-plugin
export default {"tooltip":"Vo-z","sharingV2":"Wo-z","sharingIconsV2":"Xo-z","links":"Yo-z","link":"Zo-z","facebookV2":"_o-z","twitterV2":"ap-z","pinterestV2":"bp-z"};